<template>
    <div class="recruit-page">
        <div class="center">
            <div class="block recruit-block">
                <div class="block-title">{{lang.jobList}}</div>
                <table class="recruit-list">
                    <thead>
                        <tr>
                            <th style="width:20%;">{{lang.recruitPost}}</th>
                            <th style="width:25%;">{{lang.recruitAddress}}</th>
                            <th style="width:25%;">{{lang.recruitDegree}}</th>
                            <th style="width:15%;">{{lang.recruitExp}}</th>
                            <th style="width:15%;">{{lang.recruitSalary}}</th>
                        </tr>
                    </thead>
                    <tbody><tr><td style="height: 16px;"></td></tr></tbody>
                    <tbody>
                        <tr v-for="(item, index) in jdList" :key="index" @click="goJD(item.recruitmentId)">
                            <td>{{isCn?item.cnJobName:item.enJobName}}</td>
                            <td>{{isCn?item.cnWorkplace:item.enWorkplace}}</td>
                            <td>{{isCn?item.cnEducationRequirement:item.enEducationRequirement}}</td>
                            <td>{{isCn?item.cnWorkYears:item.enWorkYears}}</td>
                            <td>{{isCn?item.cnSalaryRange:item.enSalaryRange}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="page-block">
                <Pagination :page="page" :totalPage="totalPage" @pageChange="pageChange"></Pagination>
            </div>
        </div>
    </div>
</template>

<script>
import getLang from '@/utils/main/language';
import Layout from '@/views/Layout.vue';
import Pagination from '@/components/list/Pagination.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'aboutRecruit',
    components: {
        Layout,
        Pagination,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            jdList: [],
            page: 1,
            totalPage: 1,
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        getList() {
            ajax.get('/web/about_us/recruitment_list.json', { page: this.page, pageSize: 10 }).then((result) => {
                this.jdList = result.dataList;
                this.totalPage = result.totalPage;
                this.page = result.page;
            }).catch(() => {});
        },
        pageChange(page) {
            this.page = page;
            this.getList();
        },
        goJD(id) {
            this.$router.push({ name: 'jd', query: { id } });
        },
    },
};
</script>
<style lang="less" scoped>
    .recruit-page {
        border-top: 8px solid #F8FAF9;
        padding-top: 25px;
    }
    .center {
        width: 960px;
        margin: 0 auto;
    }
    .block-title {
        color: #C71F4B;
        font-size: 18px;
        padding: 15px 0;
    }
    .recruit-list {
        width: 100%;
        margin-bottom: 16px;
        thead {
            border-top: 1px solid #F1F1F1;
            border-bottom: 1px solid #F1F1F1;
            th {
                height: 44px;
                line-height: 44px;
                font-weight: 500;
                font-size: 16px;
            }
            th:first-child {
                text-align: left;
            }
        }
        tbody td {
            padding: 8px;
            line-height: 16px;
            font-weight: 400;
            text-align: center;
            color: #9B9B9B;
        }
        tbody tr:hover {
            cursor: pointer;
            background: #F1F1F1;
            td:first-child {
                color: #C71F4B;
            }
        }
    }
    .page-block {
        border-top: 1px solid #F1F1F1;
        padding: 32px 0 62px;
    }
</style>
